import { TFunction } from "i18next";

export const PREDEFINED_GROUPS = (t: TFunction) => ({
  "pedagogy-director": [
    { id: 'group:all_teachers', label: t('all_teachers'), role: 'group' as const },
    { id: 'group:all_students', label: t('all_students'), role: 'group' as const },
    { id: 'group:all_guardians', label: t('all_guardians'), role: 'group' as const },
  ],
  manager: [
    { id: 'group:all_teachers', label: t('all_teachers'), role: 'group' as const },
    { id: 'group:all_students', label: t('all_students'), role: 'group' as const },
    { id: 'group:all_guardians', label: t('all_guardians'), role: 'group' as const },
  ],
  director: [
    { id: 'group:all_teachers', label: t('all_teachers'), role: 'group' as const },
    { id: 'group:all_students', label: t('all_students'), role: 'group' as const },
    { id: 'group:all_guardians', label: t('all_guardians'), role: 'group' as const },
  ],
  guardian: [
    { id: 'group:all_teachers_of_my_children', label: t('all_teachers_of_my_children'), role: 'group' as const },
    // { id: 'group:all_director', label: t('director'), role: 'group' as const }
  ],
  teacher: [
    { id: 'group:all_director', label: t('all_director'), role: 'group' as const },
  ],
  student: [
    // { id: 'group:all_director', label: t('director'), role: 'group' as const },
  ],
});
